import { render, staticRenderFns } from "./StatusTabs.vue?vue&type=template&id=1cdeb73e&"
import script from "./StatusTabs.vue?vue&type=script&lang=ts&"
export * from "./StatusTabs.vue?vue&type=script&lang=ts&"
import style0 from "./StatusTabs.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports